import { Box } from '@mui/material';

import { getTimeAgo } from '@/helpers/datetime-helper';

import DateTimeWrapper from '../shared/datetime-wrapper';
import ClockIcon from '../shared/icons/clock-icon';

const UltimaActualizacionComponent = ({ date, ...props }) => {
    if (!date) {
        return null;
    }

    return (
        <Box
            fontSize={12}
            gap={0.5}
            display={'flex'}
            justifyContent={'flex-end'}
            alignItems={'center'}
            mt={1}
            {...props}
        >
            <ClockIcon width={15} />{' '}
            <DateTimeWrapper date={date} format={getTimeAgo} style={{ fontSize: '14px' }} />
        </Box>
    );
};

export default UltimaActualizacionComponent;
